import { getController } from '../service'

const url = 'task_types'

export const taskTypeService = {
	...getController<Api.TaskType, Api.TaskTypePostInput>(url),
}

export default taskTypeService
